'use strict';

function Navigation() {

    var appNav = $('#app-nav');
    var pos = (appNav.length > 0) ? appNav.offset().top : 0;
    var mql = window.matchMedia('screen and (min-width: 1200px)');

    /********************************/
    // Init layout
    /********************************/
    this.initNavigation = function () {
        //this.setNavposition();
        this.initSideBarNav();
        //this.initAdvisingNav();
    };

    /********************************/
    // Set nav position
    /********************************/
    /*this.setNavposition = function () {
        if (mql.matches) { // if media query matches
            $.lockfixed('#sidebar-desktop', {offset: {top: 90, bottom: 410}});

            $(window).scroll(function () {
                appNav.toggleClass('navbar-fixed-top', ($(this).scrollTop() > pos) ? true : false);
            });
        }
    };*/

    /********************************/
    // Init side bar navigation
    /********************************/
    this.initSideBarNav = function () {

        $('#tasks').parent().hide();

        if ($('#sidebar-nav-hidden').length) {
            if ($('#sidebar-nav-hidden > li').length) {
                $('#tasks').html($('#sidebar-nav-hidden').html()).parent().show();
            }
            else {
                console.log('NAVIGATION: #sidebar-nav-hidden > li not found');
            }
        }
        else {
            console.log('NAVIGATION: #sidebar-nav-hidden not found');
            //$('#left-column').removeClass('visible-lg').hide();
            //$('#right-column').removeClass('col-lg-9').addClass('col-lg-12');
        }

        var cviewApp = $('input[name="cview_app"]').val();
        var cviewType = $('input[name="cview_type"]').val();

        //If type has value of AMD (Amendment) or WDR (Withdrawal)
        if (cviewType === 'AMD' || cviewType === 'WDR') {
            $('#sidebar-desktop').find('.glyphicon').each(function () {
                $(this).hide();
            });
        }
    };

    /********************************/
    // Init advising navigation
    /********************************/
    /*this.initAdvisingNav = function () {
        if($('#advising-pages-hidden').length){
            $('#advising-pages-hidden').find('li').each(function(){
                $('#advising-pages').find('ul').append($(this));
            });
            $('#advising-pages').show();
        }
    };*/
}

